export const shouldDisplayScheduleAMeasure = (data = {}) => (
  data?.product?.installServices?.scheduleAMeasure
  && data?.product?.taxonomy?.breadCrumbs?.[0]?.label === 'Flooring'
);